module.exports = __webpack_public_path__ + "img/8.07dbbda2.jpg";